export const enUS_error = {
  error: 'Error:',
  // Update ORDER
  ORDER_NOT_FOUND: `The order has not been found`,
  ORDER_SUSPENDED: `The order is suspended`,
  ORDER_IN_USE: `The order is already in use`,
  FLORIST_NOT_FOUND: `The florist identifier has not been found`,
  NOTIFICATION_CHANNEL_EMPTY: `An error occured in the system`,
  UPDATE_NOT_ALLOWED_WRONG_STATUS: `The order cannot be updated to this status`,
  UPDATE_NOT_ALLOWED_WRONG_EXECUTOR: `The order cannot be updated by the user`,
  UPDATE_KO: `The order status has been updated but there's an error to be checked related to invoicing`,
  EXCEPTION: `The order cannot be updated. An error has occured.`,
  UNKNOWN_EXCEPTION: `The order cannot be updated. An error has occured.`,
  OrderNotFoundException: `The order has not been found in the system`,
  IncorrectOrderActionException: `The action requested is not supported`,
  OrderStatusNotConsistentException: `The new status requested on the order is not possible`,
  InvariantException: `Technical error in the system : HTTP BAD REQUEST`,
  // POST ORDER
  IncorrectBodyModelException: `Transmission failed: Internal error - Error code: PO-01`,
  IncorrectOrderException: `Transmission failed: Internal error - Error code: PO-02`,
  BadRequestException: `Transmission failed: Internal error - Error code: PO-03`,
  Exception: `Transmission failed: Internal error - Error code: PO-04`,
  FeasabilityExceptionRaoKo: 'Transmission failed: Internal error - Error code: PO-05',
  FeasabilityExceptionRaoResponseDataKo: `Transmission failed: Internal error - Error code: PO-06`,
  FeasabilityExceptionEmptyFlorists: '`Transmission failed: Internal error - Error code: PO-07`',
  PersonalCodeExceptionPersonalCodeNotFound: `Transmission failed: Internal error - Error code: PO-08`,
  PersonalCodeExceptionExecutingFloristMismatch: `Transmission failed: Internal error - Error code: PO-09`,
  ValidationException: 'Order validation failed (missing fields) - Error code: PO-10',
  PersonalCodeNeededPsm: 'Prior approval required for custom product (PSM) - Error code: PO-11',
  PersonalCodeNeededXProduct: 'Prior approval required for product with a code ending in X - Error code: PO-12',
  PersonalCodeNeededPrice: 'Price exceeds extra-large size, approval code required - Error code: PO-12',
  PersonalCodeNeededPreparationTime: 'Prior approval required, preparation time too short - Error code: PO-13',
  PersonalCodeNeededHourLimit:
    'Prior approval required, delivery time too short for the selected time - Error code: PO-14',
  SelectedExecutingFloristNotFound: `Executing florist not found - Error code: PO-15`,
  UpdatePersonalCodeKO: 'Unable to update the AP code because it is already in use.',
  // LOGIN
  loginError: {
    floristUnknown: {
      title: `The florist's login was not found.`,
      body: `Please click on the "Logout" button.`,
    },
    noCountryCode: {
      title: `The florist's country code was not found.`,
      body: `Please click on the "Logout" button.`,
    },
    logoutButton: 'Logout',
  },
};
